export const CONNECT_WS = "connectWs";
export const DISCONNECT_WS = "disconnectWs";